import { VIEW_MED_LIST } from '@/common/permissionConstants';
import { useFeatureFlags } from '@/composables/useFeatureFlags';
import { useAuthStore } from '@/stores/auth';

// The account switch, not a permission: an account that does not administer medications has no
// eMAR to reach, however the address was arrived at. Nor does one the eMAR has not been released to.
const emarEnabledGuard = () => {
    if (!useFeatureFlags().isEnabled('emar')) return { name: 'home' };
    if (!useAuthStore().account?.medicationAdministrationEnabled) return { name: 'home' };
};

export default [
    {
        // The tab is part of the address so a report can be linked to. The route NAME stays
        // `medication-pass`: renaming it would break every existing deep link for no user-visible gain.
        path: 'e-mar/:activeTab?',
        name: 'medication-pass',
        meta: {
            label: 'eMAR',
            // Reading the day is a supervisor's job as much as a nurse's, so the route gates on
            // viewing the med list. Administering gates the controls, not the page.
            hasPermission: VIEW_MED_LIST,
        },
        component: () => import('@/views/MedicationPassPage.vue'),
        beforeEnter: emarEnabledGuard,
    },
];
